import { Alert, AlertTitle } from "@mui/material";
import localisations from "../../localisation";

type FileHttpErrorPaneProps = {
    errorMessage: string | undefined;
};

function FileHttpErrorPane(props: FileHttpErrorPaneProps) {
    const { title, description } = localisations.fileHttpErrorPane;

    return (
        <Alert severity="error">
            <AlertTitle>{title}</AlertTitle>
            <p>{description}</p>
            <p>{props.errorMessage ?? ""}</p>
        </Alert>
    );
}

export default FileHttpErrorPane;
